// import "./styles.css";
import React from "react";
import style from "./FormComoponent.module.css";
const DiffrenceTable = ({ colData }) => {
  return (
    <div>
      <table className={style["tableStyle"]}>
        <thead>
          <tr>
            <th>Sr. No</th>
            <th>Description of Fraud</th>
            <th>Preventive/Corrective actions taken</th>
          </tr>
        </thead>
        <tbody>
          {colData.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.fraudDescription}</td>
              <td>
                {item.preventiveMeasures.split("\n").map((measure, idx) => (
                  <div key={idx}>{measure}</div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ height: "30px" }}></div>
      {/* <h1 className={style["subHeading-part-one"]}>Others:</h1>
      <div className={style["div-flex-content"]}>
        <h1>Category – Complaints</h1>
      </div>
      <table className={style["tableStyle"]}>
        <thead>
          <tr>
            <th>Sr. No</th>
            <th>Description of Fraud</th>
            <th>Preventive/Corrective actions taken</th>
          </tr>
        </thead>
        <tbody>
          {colData.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.fraudDescription}</td>
              <td>
                {item.preventiveMeasures.split("\n").map((measure, idx) => (
                  <div key={idx}>{measure}</div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
    </div>
  );
};

export default DiffrenceTable;
